'use strict';

export enum PowObjectDisplaySize {
  Small = 'small',
  Large = 'large',
}
